module.exports = __webpack_public_path__ + "img/per2.e15540fd.png";